import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/rent-object-booking-extras/rent-objects/${formData.id}`, formData);
  },
  async findAll(formData) {
    return axios.get(`/rent-object-booking-extras/rent-objects/${formData.id}`);
  },
  async delete({ id }) {
    return axios.delete(`/rent-object-booking-extras/${id}`);
  },
};
